import {
  Component,
  OnInit
} from '@angular/core';
import {
  Subscription
} from 'rxjs';
import {
  ActivatedRoute
} from '@angular/router';
import {
  UserApi,
  BilanEcoLine,
  BilanEco
} from 'src/app/models/api_models/user';
import {
  UserApiService
} from 'src/app/user-api.service';
import {
  BookService
} from 'src/app/api/book.service';
import {
  BookResult
} from 'src/app/models/api_models/book';
import {
  CancelConfirmData,
  BookCancelConfirmDialogComponent
} from '../book/book-cancel-confirm-dialog/book-cancel-confirm-dialog.component';
import {
  MatDialog
} from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-book-detail',
  templateUrl: './book-detail.component.html',
  styleUrls: ['./book-detail.component.scss']
})
export class BookDetailComponent implements OnInit {

  private routeSub: Subscription;
  private langSubscription!: Subscription;

  constructor(    public translate: TranslateService, private route: ActivatedRoute, private userService: UserApiService, private bookService: BookService, public dialog: MatDialog) {}

  private _canCancel: boolean = false;
  get canCancel(): boolean {
    if (this._book != null) {
      if (this._canCancel && this.book.status == "reserved") {
        return true;
      }
    }
    return false
  }


  private _user: UserApi = null;
  get user(): UserApi {
    return this._user;
  }
  set uset(user: UserApi) {
    this._user = user;
  }

  private _book: BookResult = null;
  get book(): BookResult {
    return this._book;
  }
  set book(book: BookResult) {
    this._book = book;
  }

  private _start: Date = null;
  get start(): Date {
    return this._start;
  }
  set start(start: Date) {
    this._start = start;
  }

  private _end: Date = null;
  get end(): Date {
    return this._end;
  }
  set end(end: Date) {
    this._end = end;
  }

  private _bilanEco: BilanEcoLine;
  get bilanEco(): BilanEcoLine {
    return this._bilanEco;
  }
  set bilanEco(bilanEco: BilanEcoLine) {
    this._bilanEco = bilanEco;
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
     // Nettoyer la souscription pour éviter les fuites de mémoire
     if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  public openConfirm() {

    if (this._end.getTime() > this._start.getTime()) {
      let oldEnd = new Date(this._book.enddate);
      oldEnd.setTime(oldEnd.getTime() - 1000 * 60 * 60 * 2);
      const dialogRef = this.dialog.open(BookCancelConfirmDialogComponent, {
        data: new CancelConfirmData(this._book, this._start, this._end),
      });
      dialogRef.afterClosed().subscribe(
        result => {
          // console.log(result);
        }
      );
    }
  }


  ngOnInit() {
    // Écouter le changement de langue
    this.langSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.onLanguageChange(event.lang);
    });

    this.userService.getCurrentUserData().subscribe(
      response => {
        this._user = response;
      }
    );
    this.routeSub = this.route.params.subscribe(params => {
      if (params['id'] != null) {

        let lang = this.translate.currentLang;

        this.bookService.getBookDetail(params['id'], lang).subscribe(
          response => {
            this._book = response;
            this._start = new Date(this._book.startdate);
            this._end = new Date(this._book.enddate);
            const d = new Date();
            if ((d.getTime() + (3600 * 1000))  > this._start.getTime()) {
              this._canCancel == true;
            }
            this._start.setTime(this._start.getTime() - 1000 * 60 * 60 * 2);
            this._end.setTime(this._end.getTime() - 1000 * 60 * 60 * 2);
            if (this._book.status == "complited") {
              this.bookService.getBookBilanEco(this._book).subscribe(
                response => {
                  if (response !== null && response.list.length > 0) {

                    for (const item of response.list) {
                      if (item.booking_id == this._book.id) {
                        this._bilanEco = item;
                        break;
                      }
                    }
                  }
                }
              );
            }
          }
        );
      }
    });
  }


  onLanguageChange(lang: string): void {
    console.log('Langue changée en :', lang);
    // Appelle ici ta fonction spécifique
    this.routeSub = this.route.params.subscribe(params => {
      if (params['id'] != null) {

        let lang = this.translate.currentLang;

        this.bookService.getBookDetail(params['id'], lang).subscribe(
          response => {
            this._book = response;
            this._start = new Date(this._book.startdate);
            this._end = new Date(this._book.enddate);
            const d = new Date();
            if ((d.getTime() + (3600 * 1000))  > this._start.getTime()) {
              this._canCancel == true;
            }
            this._start.setTime(this._start.getTime() - 1000 * 60 * 60 * 2);
            this._end.setTime(this._end.getTime() - 1000 * 60 * 60 * 2);
            if (this._book.status == "complited") {
              this.bookService.getBookBilanEco(this._book).subscribe(
                response => {
                  if (response !== null && response.list.length > 0) {

                    for (const item of response.list) {
                      if (item.booking_id == this._book.id) {
                        this._bilanEco = item;
                        break;
                      }
                    }
                  }
                }
              );
            }
          }
        );
      }
    });
  }



}
